
const ModalEditarUnidade = ({
    editingTenant,
    editOwnerPhone, setEditOwnerPhone,
    editAdmins, setEditAdmins,
    editPlan, setEditPlan,
    editCycle, setEditCycle,
    editDueDate, setEditDueDate,
    SUBSCRIPTION_PLANS,
    BILLING_CYCLES,
    setIsEditing,
    setEditingTenant,
    handleSaveTenantDetails
}) => {
    return (
        <div className="master-modal-overlay">
            <div className="master-modal">
                <h3>Configurar Unidade</h3>
                <p style={{ color: 'var(--text-dim)', marginBottom: '30px' }}>Editando: <strong>{editingTenant?.name}</strong></p>

                <div className="m-form-group">
                    <label>WhatsApp do Responsável</label>
                    <input value={editOwnerPhone} onChange={e => setEditOwnerPhone(e.target.value)} />
                </div>
                <div className="m-form-group">
                    <label>E-mails Administrativos</label>
                    <input value={editAdmins} onChange={e => setEditAdmins(e.target.value)} autoFocus />
                </div>
                <div className="m-form-group">
                    <label>Plano de Assinatura</label>
                    <select value={editPlan} onChange={e => setEditPlan(e.target.value)}>
                        {Object.entries(SUBSCRIPTION_PLANS).map(([id, p]) => (
                            <option key={id} value={id}>{p.name} - R$ {p.price.toFixed(2)} ({p.limit === 999 ? 'Ilimitado' : `Até ${p.limit} barbeiros`})</option>
                        ))}
                    </select>
                </div>
                <div className="m-form-group">
                    <label>Ciclo de Faturamento</label>
                    <select value={editCycle} onChange={e => setEditCycle(e.target.value)}>
                        {BILLING_CYCLES.map((c) => (
                            <option key={c.months} value={c.months}>{c.name} {c.discount > 0 ? `(${c.discount}% de desconto)` : ''}</option>
                        ))}
                    </select>
                </div>

                <div className="m-form-group">
                    <label>Data de Vencimento</label>
                    <input
                        type="date"
                        value={editDueDate}
                        onChange={e => setEditDueDate(e.target.value)}
                    />
                    <p className="m-field-desc">
                        Deixe em branco para acesso ilimitado.
                    </p>
                </div>

                <div className="m-modal-actions">
                    <button className="modal-btn secondary" onClick={() => { setIsEditing(false); setEditingTenant(null); }}>Cancelar</button>
                    <button className="modal-btn primary" onClick={handleSaveTenantDetails}>Salvar Alterações</button>
                </div>
            </div>
        </div>
    );
};

export default ModalEditarUnidade;
